module.exports = __webpack_public_path__ + "static/media/ilo-dark.dbf80288.webp";